<script>
const iconMap = {
  index: {
    active: require('@/assets/images/nav/home-active.png'),
    default: require('@/assets/images/nav/home.png')
  },
  classify: {
    active: require('@/assets/images/nav/classify-active.png'),
    default: require('@/assets/images/nav/classify.png')
  },
  store: {
    active: require('@/assets/images/nav/store-active.png'),
    default: require('@/assets/images/nav/store.png')
  },
  storeManage: {
    active: require('@/assets/images/nav/storeManage-active.png'),
    default: require('@/assets/images/nav/storeManage.png')
  },
  knowledgeList: {
    active: require('@/assets/images/nav/knowledge-active.png'),
    default: require('@/assets/images/nav/knowledge.png')
  },
  myAgentList: {
    active: require('@/assets/images/nav/myAgent-active.png'),
    default: require('@/assets/images/nav/myAgent.png')
  },
  course: {
    active: require('@/assets/images/nav/video-active.png'),
    default: require('@/assets/images/nav/video.png')
  },
  document:{
    active: require('@/assets/images/nav/fileCenter-active.png'),
    default: require('@/assets/images/nav/fileCenter.png')
  },
  myClassify:{
    active: require('@/assets/images/nav/myClassify-active.png'),
    default: require('@/assets/images/nav/myClassify.png')
  },
  '/company':{
    active: require('@/assets/images/nav/company-active.png'),
    default: require('@/assets/images/nav/company.png')
  },
  myBanner:{
    active: require('@/assets/images/nav/myBanner-active.png'),
    default: require('@/assets/images/nav/myBanner.png')
  },
  myLogo:{
    active: require('@/assets/images/nav/myLogo-active.png'),
    default: require('@/assets/images/nav/myLogo.png')
  },
  userManage:{
    active: require('@/assets/images/nav/userManage-active.png'),
    default: require('@/assets/images/nav/userManage.png')
  },
  dialogManage:{
    active: require('@/assets/images/nav/dialogManage-active.png'),
    default: require('@/assets/images/nav/dialogManage.png')
  },
  bannerManage:{
    active: require('@/assets/images/nav/bannerManage-active.png'),
    default: require('@/assets/images/nav/bannerManage.png')
  },
  logoManage:{
    active: require('@/assets/images/nav/logoManage-active.png'),
    default: require('@/assets/images/nav/logoManage.png')
  },
  board:{
    active: require('@/assets/images/nav/board-active.png'),
    default: require('@/assets/images/nav/board.png')
  },
  videoGeneration: {
    active: require('@/assets/images/nav/videoGeneration-active.png'),
    default: require('@/assets/images/nav/videoGeneration.png')
  },
  imageGeneration: {
    active: require('@/assets/images/nav/imageGeneration-active.png'),
    default: require('@/assets/images/nav/imageGeneration.png')
  },
  digitalHuman: {
    active: require('@/assets/images/nav/digitalHuman-active.png'),
    default: require('@/assets/images/nav/digitalHuman.png')
  },
  newDigitalHuman: {
    active: require('@/assets/images/nav/digitalHuman-active.png'),
    default: require('@/assets/images/nav/digitalHuman.png')
  },
  audioToText: {
    active: require('@/assets/images/nav/audioToText-active.png'),
    default: require('@/assets/images/nav/audioToText.png')
  },
  newVideoGeneration: {
    active: require('@/assets/images/nav/videoGeneration-active.png'),
    default: require('@/assets/images/nav/videoGeneration.png')
  },
  pointRecord: {
    active: require('@/assets/images/nav/pointRecord-active.png'),
    default: require('@/assets/images/nav/pointRecord.png')
  },
  'http://geo.yinheshujie.com': {
    active: require('@/assets/images/nav/geo-active.png'),
    default: require('@/assets/images/nav/geo.png')
  },
  pointPackage: {
    active: require('@/assets/images/nav/pointPackage-active.png'),
    default: require('@/assets/images/nav/pointPackage.png')
  },
  pointRecharge: {
    active: require('@/assets/images/nav/pointRecharge-active.png'),
    default: require('@/assets/images/nav/pointRecharge.png')
  }
};
function getIcon(key, activeMenu) {
  if (!iconMap[key]) return null;
  const isActive = (key === 'index' && (activeMenu === '' || activeMenu === '/index')) || 
          (key === 'classify' && activeMenu === '/classify') ||
          (key === 'store' && activeMenu === '/store') ||
          (key === 'storeManage' && activeMenu === '/storeManage') ||
          (key === 'knowledgeList' && activeMenu === '/knowledgeList') || 
          (key === 'myAgentList' && activeMenu === '/myAgentList') || 
          (key === 'course' && activeMenu === '/course') ||
          (key === 'document' && activeMenu === '/document') ||
          (key === 'myClassify' && activeMenu === '/myClassify') ||
          (key === '/company' && (activeMenu === '/company/companyList' || activeMenu === '/company/companyAudit' || activeMenu === '/company/companyRecord')) ||
          (key === 'myBanner' && activeMenu === '/myBanner') ||
          (key === 'myLogo' && activeMenu === '/myLogo') ||
          (key === 'userManage' && activeMenu === '/userManage') ||
          (key === 'dialogManage' && activeMenu === '/dialogManage') ||
          (key === 'bannerManage' && activeMenu === '/bannerManage') ||
          (key === 'logoManage' && activeMenu === '/logoManage') || 
          (key === 'board' && activeMenu === '/board') || 
          (key === 'videoGeneration' && activeMenu === '/videoGeneration') ||
          (key === 'imageGeneration' && activeMenu === '/imageGeneration') ||
          (key === 'digitalHuman' && activeMenu === '/digitalHuman') ||
          (key === 'newDigitalHuman' && activeMenu === '/newDigitalHuman') ||
          (key === 'audioToText' && activeMenu === '/audioToText') ||
          (key === 'newVideoGeneration' && activeMenu === '/newVideoGeneration') ||
          (key === 'pointRecord' && activeMenu === '/pointRecord') ||
          (key === 'http://geo.yinheshujie.com' && activeMenu === 'http://geo.yinheshujie.com') ||
          (key === 'pointPackage' && activeMenu === '/pointPackage') ||
          (key === 'pointRecharge' && activeMenu === '/pointRecharge')
  return isActive ? iconMap[key].active : iconMap[key].default;
}
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
    ,
    name: {
      type: String,
      default: ''
    },
    activeMenu: {
      type: String,
      default: ''
    },
  },
  render(h, context) {
    const { icon, title, name, activeMenu } = context.props
    const vnodes = []

    if (icon && getIcon(name, activeMenu)) {
      vnodes.push(<img src={getIcon(name, activeMenu)}/>)
    }

    if (title) {
      if (title.length > 5) {
        vnodes.push(<span slot='title' title={(title)}>{(title)}</span>)
      } else {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
    }
    return vnodes
  }
}
</script>
